"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require("../internals/typed-array-constructors-require-wrappers");
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;
exportTypedArrayStaticMethod("of", function of() {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor(this))(length);
  while (length > index) result[index] = arguments[index++];
  return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
